const COOKIE_NAME = '_cc_attribution';

export type SignupAttribution = {
  schema_version?: number;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  source?: string;
  landing_page?: string;
  first_touch_time?: string;
  extra_params?: Record<string, string>;
  click_ids?: Record<string, string>;
};

const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export function getAttributionCookie(): SignupAttribution | undefined {
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`),
  );
  if (!match) return undefined;
  try {
    return JSON.parse(decodeURIComponent(match[1]));
  } catch {
    return undefined;
  }
}

export function getUrlAttribution(
  searchParams: URLSearchParams,
): SignupAttribution | undefined {
  const attribution: SignupAttribution = {};
  for (const param of UTM_PARAMS) {
    const value = searchParams.get(param);
    if (value) {
      attribution[param] = value;
    }
  }
  const source = searchParams.get('source');
  if (source) {
    attribution.source = source;
  }
  return Object.keys(attribution).length > 0 ? attribution : undefined;
}

export function getSignupAttribution(
  searchParams: URLSearchParams,
): SignupAttribution | undefined {
  const cookieAttribution = getAttributionCookie();
  const urlAttribution = getUrlAttribution(searchParams);
  if (!cookieAttribution && !urlAttribution) return undefined;
  return { ...cookieAttribution, ...urlAttribution };
}
